import React from "react";
import Reveal from "./Reveal";
import { PROFILE } from "../data/resume";

// Phrases from the profile set in the accent face; the text itself is unchanged.
const HIGHLIGHTS = ["full-stack web/mobile applications", "AI-powered solutions", "scalable software systems", "BIM technologies"];

const highlight = (text) => {
    const pattern = new RegExp(`(${HIGHLIGHTS.map((phrase) => phrase.replace(/[.*+?^${}()|[\]\\/]/g, "\\$&")).join("|")})`);
    return text.split(pattern).map((part, index) =>
        HIGHLIGHTS.includes(part) ? (
            <span key={index} className="serif-accent text-[1.08em] text-accent-text">
                {part}
            </span>
        ) : (
            part
        )
    );
};

const Profile = () => (
    <section id="profile" aria-labelledby="profile-title" className="pb-12 pt-4 md:pb-16 lg:pt-12">
        <Reveal variant="fade">
            <h2 id="profile-title" className="label text-fg">
                <span className="text-accent-text">(00)</span>
                <span className="ml-2">Profile</span>
            </h2>
        </Reveal>
        <Reveal delay={150}>
            <p className="mt-6 max-w-[46rem] text-[clamp(1.4rem,2.35vw,2.15rem)] font-medium leading-[1.22] tracking-[-0.02em] text-pretty">
                {highlight(PROFILE)}
            </p>
        </Reveal>
    </section>
);

export default Profile;
